import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import {LayoutComponent} from './components/layout/layout.component';
import {GeneralDataComponent} from './components/general-data/general-data.component';
import { OptionsComponent } from './components/options/options.component';
import { IdentificationComponent } from './components/identification/identification.component';
import { ProfAddressComponent } from './components/prof-address/prof-address.component';
import { AssistedOpeningComponent } from './components/assisted-opening/assisted-opening.component';
import { AdditionalDataComponent } from './components/additional-data/additional-data.component';
import { BeneficiaryComponent } from './components/beneficiary/beneficiary.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { AutonomousOpeningComponent } from './components/autonomous-opening/autonomous-opening.component';
import { AdminGuard } from './admin.guard';

const routes: Routes = [
  {
    path:'',
    component:LayoutComponent,
    children:[
      {
        path:'',
        redirectTo:'registro',
        pathMatch:'full'
      },
      {
        path:'registro',
        component:GeneralDataComponent,
        data: { title: 'Datos Generales' }
      },
      {
        path:'registro/:from',
        component:GeneralDataComponent,
        data: { title: 'Datos Generales' }
      },
      {
        path: 'opciones',
        component: OptionsComponent,
        data: { title: 'Seleccion de Abrir Contrato' },
        canActivate:[AdminGuard]
      },
      {
        path: 'opciones/asistido-thank-you-page',
        component: AssistedOpeningComponent,
        data: { title: 'Apertura Asistida' },
        canActivate:[AdminGuard]
      },
      {
        path: 'opciones/autonomo-identificacion',
        component: IdentificationComponent,
        data: { title: 'Identificacion Oficial' },
        canActivate:[AdminGuard]
      },
      {
        path: 'opciones/autonomo-comprobante',
        component: ProfAddressComponent,
        data: { title: 'Comprobante de Domicilio' },
        canActivate:[AdminGuard]
      },
      {
        path: 'opciones/autonomo-completa-informacion',
        component: AdditionalDataComponent,
        data: { title: 'Completa Informacion' },
        canActivate:[AdminGuard]
      },
      {
        path: 'opciones/autonomo-beneficiario',
        component: BeneficiaryComponent,
        data: { title: 'Beneficiario' },
        canActivate:[AdminGuard]
      },
      {
        path: 'opciones/autonomo-confirmacion',
        component: ConfirmationComponent,
        data: { title: 'Confirmacion' },
        canActivate:[AdminGuard]
      },
      {
        path: 'opciones/autonomo-thank-you-page',
        component: AutonomousOpeningComponent,
        data: { title: 'Apertura Autonoma' },
        canActivate:[AdminGuard]
      },    
    ]
  },
  {
    path:'**',
    redirectTo:'registro'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    useHash: true,
    preloadingStrategy:PreloadAllModules
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
